export default (tourCriteria) => {
    const params = {};
    const element = tourCriteria.get('isExclusive');
    if (element) {
        params.isExclusive = element;
    }

    return params;
};